import { useEffect, useState } from 'react'

// Credits: https://github.com/tailwindlabs/headlessui/blob/a8bbd0ecee2ac608a6c64e7fce8c1b551444b63d/packages/@headlessui-react/src/hooks/use-server-handoff-complete.ts

const state = { serverHandoffComplete: false }

export function useServerHandoffComplete(): boolean {
	const [serverHandoffComplete, setServerHandoffComplete] = useState(state.serverHandoffComplete)

	useEffect(() => {
		if (serverHandoffComplete) {
			return
		}

		setServerHandoffComplete(true)
	}, [serverHandoffComplete])

	useEffect(() => {
		if (!state.serverHandoffComplete) {
			state.serverHandoffComplete = true
		}
	}, [])

	return serverHandoffComplete
}
